import React from 'react';

function MottoKami() {
    return (
        <div>
            <div className="section-dark resume">
                <div className="container">
                    <div
                        className="columns is-multiline"
                        data-aos="fade-in"
                        data-aos-easing="linear"
                    >
                        <div className="column is-12 about-me">
                            <h1 className="title has-text-centered section-title">
                                Motto Kami
                            </h1>
                        </div>
                        <div className="column is-10 has-text-centered is-offset-1">
                            <h2 className="subtitle">
                                Mempertemukan Talenta Digital dengan Clientnya
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MottoKami;
